import SchoolItem from '@pages/Home/components/SchoolItem'
import React from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { RootState } from 'store'
import { Type_Initstate } from 'store/appSlice'

function SchoolDetailItem() {
  const appState = useSelector<RootState, Type_Initstate>((state) => state.app)
  const { listEdubillDetail } = appState
  const params = useParams()

  return (
    <div className="pb-6">
      <div className="md:text-[22px] text-[16px] font-bold text-center md:mt-[10vh] mt-[4vh] text-[#045993]">
        Chọn trường
      </div>
      <div className="md:text-[18px] text-[16px] text-center mt-3">
        Vui lòng chọn trường để tiếp tục tra cứu thông tin học phí
      </div>
      <div className="flex justify-center items-start gap-[37px] self-stretch mt-10 flex-wrap">
        {/* {listSchool.map((e, i) => (
          <SchoolItem item={e} key={i} />
        ))} */}

        {[
          ...listEdubillDetail.filter((item) => item.status !== 0).filter((item) => item.orgCode === params.orgCode),
        ].map((e, i) => (
          <SchoolItem item={e} key={i} />
        ))}
      </div>
    </div>
  )
}

export default SchoolDetailItem
